import React, { useEffect, useMemo, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { toast } from "react-toastify";
import {
  FlexRowBetween,
  Input,
  ListHolder,
  PlaceHolderImage,
  RespFont,
  UserCard,
} from "../common/Style";
import {
  dateFormat,
  days,
  handleClickScroll,
} from "../common/others/Functions";
import FilledLoading from "../common/loader/FilledLoading";
import EditUser from "./EditUser";
import GenericModal from "../common/modals/GenericModal";
import logout from "../../assets/common/logout.svg";
import clear from "../../assets/common/clear.svg";
import plus from "../../assets/common/plus.svg";

import LogoutSpecipic from "../common/LogOut/LogoutSpecipic";
import BottomMenu from "../common/others/BottomMenu";
import AddUser from "./AddUser";
import { getAllEfrat } from "../../store/reducers/efratReducer";

const MainEfrat = () => {
  const [searchText, setSearchText] = useState("");
  const inputRef = useRef();

  const { efrats } = useSelector((state) => state.efratReducer);
  const { user } = useSelector((state) => state.authReducer);
  const [loading, setLoading] = useState(false);
  const [user2edit, setUser2edit] = useState(false);
  const [showLogout, setShowLogout] = useState(false);
  const [showAddUser, setShowAddUser] = useState(false);

  const handleGetAllAfterAdd = async () => {
    setShowAddUser(false);
    setUser2edit(false);
    handleGetAll();
  };

  const dispatch = useDispatch();

  const handleGetAll = async () => {
    setLoading(true);
    dispatch(getAllEfrat()).then((res) => {
      if (res.payload?.error) toast.error(res.payload?.error);
      setLoading(false);
    });
  };

  useEffect(() => {
    handleGetAll();
  }, []);

  useEffect(() => {
    setTimeout(function () {
      handleClickScroll("todayBla");
    }, 1000);
  }, []);

  let guestsArray = useMemo(() => {
    let arr = [];
    let sortedArr = [];
    if (Object.keys(efrats).length > 0)
      for (const [key, value] of Object.entries(efrats))
        if (
          searchText
            .toLowerCase()
            .split(" ")
            .filter((i) =>
              value.brideName?.toLowerCase().includes(i.toLowerCase())
            ).length === searchText.toLowerCase().split(" ").length ||
          searchText
            .toLowerCase()
            .split(" ")
            .filter((i) =>
              value.groomName?.toLowerCase().includes(i.toLowerCase())
            ).length === searchText.toLowerCase().split(" ").length ||
          value.bridePhone.includes(searchText) ||
          searchText === ""
        )
          sortedArr.push(value);
    let date = new Date();
    date.setHours(3);
    date.setMinutes(0);
    date.setSeconds(0);
    sortedArr.push({
      calendarName: "today",
      date: date.toISOString(),
    });
    date.setFullYear(date.getFullYear() - 1);
    sortedArr.push({
      calendarName: "before",
      date: date.toISOString(),
    });
    sortedArr.sort((a, b) => new Date(a["date"]) - new Date(b["date"]));

    for (let i = 0; i < sortedArr.length; i++) {
      if (sortedArr[i].calendarName === "today")
        arr.push(
          <FlexRowBetween
            key={"bookmark"}
            style={{
              backgroundColor: "#7b96c4",
              height: "3px",
              marginTop: "10px",
            }}
            id={"todayBla"}
          />
        );
      else if (sortedArr[i].calendarName === "before")
        arr.push(
          <FlexRowBetween
            key={"bookmark"}
            style={{
              backgroundColor: "#7b96c4",
              height: "3px",
              marginTop: "10px",
            }}
            id={"beforeBla"}
          />
        );
      else {
        if (sortedArr[i].seatupEventId == "besimple")
          if (!user.isItay) continue;
        arr.push(
          <UserCard
            border={
              days(new Date(), new Date(sortedArr[i].date)) >= 1
                ? "#ec7070"
                : "#7b96c4"
            }
            key={i}
            onClick={() => setUser2edit(sortedArr[i])}
          >
            <RespFont>
              {`${sortedArr[i].brideName} ו${sortedArr[i].groomName}`}
            </RespFont>
            <RespFont>{dateFormat(sortedArr[i].date)}</RespFont>
          </UserCard>
        );
      }
    }

    return arr;
  }, [efrats, searchText]);

  return (
    <div
      style={{
        width: "100%",
        height: `${window.screen.availHeight}px`,
      }}
    >
      <BottomMenu
        data={[
          <img
            key={3}
            src={plus}
            alt="plus"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowAddUser(true)}
          />,
          <img
            key={4}
            src={logout}
            alt="logout"
            style={{ width: "31px", padding: "10px 0", cursor: "pointer" }}
            onClick={() => setShowLogout(true)}
          />,
        ]}
      />
      <FlexRowBetween>
        <div
          style={{
            position: "relative",
            marginRight: "0px",
            width: "150px",
          }}
        >
          <PlaceHolderImage
            onClick={() => {
              setSearchText("");
              inputRef.current.focus();
            }}
            fontSize={`28px`}
            top={`50%`}
            src={clear}
            alt="clear"
            style={{
              cursor: "pointer",
              border: "1px solid silver",
              padding: "5px",
              borderRadius: "2px",
              left: "7px",
            }}
          />
          <Input
            value={searchText}
            ref={inputRef}
            type="text"
            placeholder="חיפוש"
            name="value"
            style={{
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              padding: "7px 0px",
              paddingRight: "3px",
              border: "1px solid silver",
            }}
            // let tempPhone = phone.replaceAll(/[^\d]/g, "");
            onChange={(e) => setSearchText(e.target.value)}
          />
        </div>
      </FlexRowBetween>
      <ListHolder>{guestsArray}</ListHolder>
      {loading && <FilledLoading />}
      {user2edit && (
        <GenericModal
          init={setUser2edit}
          div={
            <EditUser
              user={user2edit}
              init={setUser2edit}
              secondInit={handleGetAllAfterAdd}
            />
          }
        />
      )}
      {showAddUser && (
        <GenericModal
          init={setShowAddUser}
          div={<AddUser init={handleGetAllAfterAdd} />}
        />
      )}
      {showLogout && (
        <GenericModal
          init={setShowLogout}
          div={<LogoutSpecipic init={setShowLogout} />}
        />
      )}
    </div>
  );
};

export default MainEfrat;
